module.exports = __webpack_public_path__ + "img/tram-colored.483079fc.svg";